import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { filter, switchMap } from 'rxjs';

import { NotificationActions, NotificationState, selectNotification } from '@public-page/store/notification';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pub-notification',
  template: '',
})
export class NotificationComponent implements OnInit {
  $notification = this.store.select(selectNotification);

  constructor(private store: Store, private notification: NzNotificationService, private translate: TranslateService) {}

  ngOnInit() {
    this.$notification
      .pipe(
        filter((val: NotificationState) => val.messageKey !== null || val.type !== null),
        switchMap(({ type, messageKey }: NotificationState) => {
          const translateValue = this.translate.instant(messageKey as string);

          return this.notification.create(type as string, '', translateValue, {
            nzClass: `pm-notification-${type}`,
          }).onClose;
        })
      )
      .subscribe(() => this.store.dispatch(NotificationActions.hide()));
  }
}
